/* Copyright 2018 VMware, Inc. All rights reserved. -- VMware Confidential */

h5 = h5 || {};
h5.devcenter = {
   angularModule: angular.module('com.vmware.vsphere.client.devcenter', [])
};